import { Component, OnInit } from '@angular/core';
import { MainTitle } from '../../models/main-title';
import { ReportConfig } from '../../models/report-config';
import { ReportService } from '../../services/report.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-insights',
  templateUrl: './insights.component.html',
  styleUrls: ['./insights.component.scss']
})
export class InsightsComponent implements OnInit {
  public title = new MainTitle('InsightsComponent.title');
  public reports?: ReportConfig[];

  constructor(private reportService: ReportService, private translate: TranslateService) {}

  ngOnInit(): void {
    this.reportService.list().subscribe((data) => {
      this.reports = data.items;
    });
  }
}
